import { useEffect } from 'preact/hooks'
import { FieldLabel } from './FieldLabel'
import { useFetch } from '../hooks/useFetch'
import Icon from '@/components/snippets/icon/icon'
import { accountTranslations } from '../helpers/translations'

const FIELD_FETCH_CONFIG_STATE = {
  INIT: 'INIT',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
}

/**
 *
 * Fetch {
 *  debounce: 5000
 *  method: POST | GET
 *  callback: (data) => {}
 *
 * }
 * @param {*} param0
 * @returns
 */
export const FieldFetchOnClick = ({ type = '', name, required, value, label, onChange, readOnly, prefix, fetch }) => {
  const { config, handleRefetch } = useFetch({
    url: 'https://my.shoesandsox.com.au/api/random-name',
    options: { method: 'GET' },
    fetchOnRender: !value
  })

  useEffect(() => {
    if (config.state === 'SUCCESS') {
      onChange({
        currentTarget: {
          name,
          value: config.data?.name
        }
      })
    }
  }, [config])

  return (
    <div className={'flex w-full flex-col gap-2'}>
      <FieldLabel label={accountTranslations.form_labels.shoe_tag} hasInput={config.data?.name} required={true} />
      <div
        className={
          'relative overflow-hidden rounded-lg border-2  border-solid border-secondary-green  bg-primary-white transition-colors'
        }
      >
        <input
          className={'min-h-12 w-full border-none px-4 pr-12 read-only:cursor-default '}
          name={name}
          value={value}
          onChange={(e) => {
            onChange({
              currentTarget: {
                name,
                value: e.target.value
              }
            })
          }}
        />
        <div
          className="absolute top-0 right-0 flex items-center justify-center h-full cursor-pointer aspect-1"
          onClick={() => {
            if (config.state !== 'FETCHING') {
              handleRefetch()
            }
          }}
          aria-label={`Generate new ${accountTranslations.form_labels.shoe_tag.toLowerCase()}`}
          title={`Generate new ${accountTranslations.form_labels.shoe_tag.toLowerCase()}`}
          aria-role="button"
        >
          <Icon id="refresh" className="text-secondary-green" />
        </div>
      </div>
    </div>
  )
}
